import * as Yup from 'yup';

export const validationSchema = Yup.object({
    // Device
    deviceType: Yup.string().required('Tipo de dispositivo é obrigatório'),
    cnpj: Yup.string().required('CNPJ é obrigatório'),
    name: Yup.string().required('Nome do dispositivo é obrigatório'),
    timezone: Yup.string().required('Timezone é obrigatório'),
    activationKey: Yup.string(),
    active: Yup.boolean(),
    expirationDate: Yup.boolean(),
    startPeriod: Yup.mixed().nullable(),
    endPeriod: Yup.mixed().nullable(),

    // Edit-only
    identity: Yup.string(),
    company: Yup.string(),
    deleted: Yup.boolean(),

    // Authorized collaborators
    collaboratorsType: Yup.string(),
    employees: Yup.array(),
    locations: Yup.array(),
    useSelectAllEmployees: Yup.boolean(),

    // Controller
    enable_password_punch: Yup.boolean(),
    break_device: Yup.boolean(),
    is_repa: Yup.boolean(),
    enableRepA: Yup.boolean(),
    enable_auto_update: Yup.boolean(),
    default_computer: Yup.boolean(),
    timezone_filter: Yup.boolean(),
    triple_validation: Yup.boolean(),
    enable_punches_logs: Yup.boolean(),
    enable_punch_backup: Yup.boolean(),
    enable_punch_by_manager: Yup.boolean(),
    save_photo_on_punch: Yup.boolean(),
    blink: Yup.boolean(),
    smile: Yup.boolean(),
    head_movement: Yup.boolean(),
    enable_facial_recognition_flow: Yup.boolean(),

    // Device for receipt
    device_for_receipt_flag_multi: Yup.boolean(),

    // Restriction
    online_only: Yup.boolean(),
    auto_timezone: Yup.boolean(),
    only_with_location: Yup.boolean(),
    only_inside_geofence: Yup.boolean(),
    range_ip: Yup.boolean(),
    ips: Yup.array(),

    // Button display
    hide_password_config_access: Yup.boolean(),
    hide_reconfigure_multi: Yup.boolean(),
    hide_punch_receipt_display_time: Yup.boolean(),
});
